import { z } from 'zod';

export const FORM_SCHEMA = z.object({
  email: z
    .string()
    .email('Invalid email address')
    .min(1, 'Required'),
  password: z.string().min(1, 'Required'),
  retailerId: z.string().min(1, 'Please choose a store')
});
